import { render } from "./EventList.vue?vue&type=template&id=c570d94a&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=c570d94a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c570d94a"

export default script